<template>
  <div class="main-box main-min-height bgffffff">
    <div class="table-box">
      <div>
        <el-form :model="searchForm" size="mini" label-width="80px" ref="searchForm">
          <el-row>
            <el-col :span="6">
              <el-form-item label-width="20px">
                <el-button type="primary" @click="Edit(false)">
                  添加
                </el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <el-table :header-cell-style="{background:'#F4F4F5'}" :data="tableData" border style="width: 100%">
        <el-table-column label="商务全称" prop="fulName" align="center"></el-table-column>
        <el-table-column label="商户简称" prop="abbreviation" align="center"></el-table-column>
        <el-table-column label="创建时间" prop="createTime" align="center"></el-table-column>
        <el-table-column label="操作" prop="createTime" align="center" width="120">
          <template slot-scope="{row}">
            <el-button size="mini" type="primary" @click="Edit(true,row)">修改</el-button>
          </template>
        </el-table-column>
      </el-table>
      <Pagination location='left' :page='page' @getData="getInfo" />
    </div>
    <Dialogs v-model="dialogEditVisible" :center='true' :title='title' :HeaderPosition='true' width-dial="800px" :height-dial="250" @dialog="submit">
      <el-form size='mini' :model="ruleForm" :rules="rules" ref="ruleForm" label-position='right' label-width="140px">
        <el-row>
          <el-col :span="12">
            <el-form-item prop="fullName" label="商务全称">
              <el-input v-model="ruleForm.fullName" style="width:100%" placeholder="-请输入-" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="abbreviation" label="商户简称">
              <el-input v-model="ruleForm.abbreviation" style="width:100%" placeholder="-请输入-" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="appId" label="appId">
              <el-input v-model="ruleForm.appId" style="width:100%" placeholder="-请输入-" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="mchId" label="商户号">
              <el-input v-model="ruleForm.mchId" style="width:100%" placeholder="-请输入-" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="paymentCallbackUrl" label="支付回调地址">
              <el-input v-model="ruleForm.paymentCallbackUrl" style="width:100%" placeholder="-请输入-" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="secrrt" label="小程序密钥">
              <el-input v-model="ruleForm.secrrt" style="width:100%" placeholder="-请输入-" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="mchSerlalno" label="商户API证书序列号">
              <el-input v-model="ruleForm.mchSerlalno" style="width:100%" placeholder="-请输入-" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="apiV3Key" label="v3私钥">
              <el-input v-model="ruleForm.apiV3Key" style="width:100%" placeholder="-请输入-" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="certificateAddress" label="证书存放地址">
              <el-input v-model="ruleForm.certificateAddress" style="width:100%" placeholder="-请输入-" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="refundCallbackUrl" label="退款回调地址">
              <el-input v-model="ruleForm.refundCallbackUrl" style="width:100%" placeholder="-请输入-" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </Dialogs>
  </div>
</template>

<script>
import Pagination from '@/components/pagination/Pagination.vue'
import Dialogs from '@/components/DiaLogs'

export default {
  name: 'MerchantManagement',
  components: {
    Pagination,
    Dialogs
  },
  data() {
    return {
      searchForm: {},//查询条件
      tableData: [],//表格参数
      page: { //翻页处理
        currentPage: 1,
        pageSize: 50,
        total: 0,
      },
      dialogEditVisible: false,
      ruleForm: {
        id:null,
        fullName: null, //商务全称
        abbreviation: null, //商户简称
        appId: null, //appId
        mchId: null, //商户号
        paymentCallbackUrl: null, //支付回调地址
        secrrt: null, //小程序密钥
        mchSerlalno: null, //商户API证书序列号
        apiV3Key: null, //v3私钥
        certificateAddress: null, //证书存放地址
        refundCallbackUrl: null, //退款回调地址
      },
      rules: {},
      title: '新增商户',
    };
  },
  computed: {},
  watch: {},
  mounted() {
    this.getInfo()
  },
  methods: {
    //获取查询信息
    getInfo(bool) {
      bool ? this.page.currentPage = 1 : ''
      this.$MerchantManagement.page(
        {
          ...this.searchForm,
          page: this.page.currentPage,
          limit: this.page.pageSize
        }
      ).then(({ data }) => {
        if (data.code === 200) {
          this.tableData = data.data
          this.page.total = data.count
        }
      })
    },
    //提交
    submit() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          let {id,...obj} = this.ruleForm
          if(id){
            this.$MerchantManagement.update({ ...this.ruleForm }).then(({ data }) => {
              if (data.code === 200) {
                this.messages(data.message, true, 1000, () => {
                  this.getInfo();
                  this.dialogEditVisible = false
                })
              }
            })
          }else{
            this.$MerchantManagement.add({...obj}).then(({ data }) => {
              if (data.code === 200) {
                this.messages(data.message, true, 1000, () => {
                  this.getInfo();
                  this.dialogEditVisible = false
                })
              }
            })
          }
        }
      });
    },
    Edit(bool,data) {
      Object.keys(this.ruleForm).forEach(item => this.ruleForm[item] = null)
      bool?this.title='修改商户信息':this.title='添加商户信息'
      if(bool){
        Object.keys(this.ruleForm).forEach(item => this.ruleForm[item] = data[item])
      }
      this.dialogEditVisible = true
    }
  }
};
</script>

<style lang="scss" scoped>
.box {
  width: 100%;
  height: 100%;
}
</style>
